export class JobTreeItem {
  constructor(node, isDir) {
    this.node = node;
    this.isDir = isDir;
    console.info('created job tree item:', this.node);
    if (this.isDir) {
      // TODO: remove once deprecated in favor of getter
      this.children = [];
    }
  }

  get id() {
    return this.node.getNodeId();
  }

  get name() {
    return this.node.getDetails().getName();
  }

  // get children() {
  //   if (!this.isDir) {
  //     return undefined;
  //   }
  //   const chList = [];
  //   // chList.push()
  //   return chList;
  // }
}

export function createFolderTreeItem(folderMap, index) {
  const folder = folderMap.get(index);
  if (!folder) {
    console.log('WARNING: no folder for declared index', index);
    return null;
  }

  const treeItem = new JobTreeItem(folder.getInfo(), true);
  console.log('FOLDER', 'id', '-', treeItem.id, treeItem.name);

  // add child files
  const childFileWrappers = folder.getChildFiles();
  if (childFileWrappers) {
    childFileWrappers.getFilesList().forEach((node) => {
      const childFile = new JobTreeItem(node, false);
      console.log('FILE', 'id', '-', treeItem.id, treeItem.name);
      console.log('createTreeItem file', 'childFileId', '-', childFile.id, node.toObject());
      treeItem.children.push(childFile);
    });
  }

  // add child folders
  const childDirs = folder.getChildDirs();
  if (childDirs) {
    for (let i = childDirs.getChildDirStartNodeId(); i <= childDirs.getChildDirEndNodeId(); i += 1) {
      const childFolder = createFolderTreeItem(folderMap, i);
      treeItem.children.push(childFolder);
    }
  }

  return treeItem;
}
